export const SET_STORIES = "setStories";
export const SET_USER_STORIES = "setUserStories";
export const SET_HAS_MORE = "setHasMore";
